import { connect } from 'react-redux';
import { compose } from 'recompose';

import { dispatchHideTimeEntryEditorModal, dispatchDeleteTimeEntry } from '../actions';

import UserTimeEntryDeleteModal from './UserTimeEntryDeleteModal';

const mapStateToProps = (state) => {
  return {
    errorMessage: state.timesheetApprovals.modalAPIErrorMessage,

    supervisorId: state.timesheetApprovals.currentSupervisorId,
  };
};

const mapDispatchToProps = {
  dispatchHideTimeEntryEditorModal,
  dispatchDeleteTimeEntry,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(withRedux);

export default enhance(UserTimeEntryDeleteModal);
